module.exports = __webpack_public_path__ + "img/flag-fr.edbdab53.svg";